interface EyeVisibilityIconProps {
	size?: number;
	className?: string;
}

const EyeVisibilityIcon = ({ size = 20, className = "" }: EyeVisibilityIconProps) => {
	const pupilSize = Math.max(3, Math.round(size * 0.25));

	return (
		<span aria-hidden="true" className={`relative inline-flex shrink-0 items-center justify-center text-current ${className}`} style={{ width: size, height: size }}>
			<span className="absolute rounded-[50%] border-[1.7px] border-current" style={{ width: size * 0.9, height: size * 0.56 }} />
			<span className="absolute rounded-full bg-current" style={{ width: pupilSize, height: pupilSize }} />
		</span>
	);
};

export default EyeVisibilityIcon;
